'use client'

import { useSearchParams } from 'next/navigation'

export default function LoadContact({
  children
}: {
  children: React.ReactNode
}) {
  const searchParams = useSearchParams()

  const flowType = searchParams.get('flow')
  if (flowType) {
    sessionStorage.setItem('flowType', flowType)
    sessionStorage.removeItem('contactSecurityToken')
    sessionStorage.setItem('restoreSession', '0')
  }

  const hideDomideal = searchParams.get('partnerDeal')
  if (hideDomideal === '1') {
    sessionStorage.setItem('hideDomideal', '1')
  }

  const securityToken = searchParams.get('token')
  if (securityToken) {
    sessionStorage.setItem('contactSecurityToken', securityToken)
    sessionStorage.setItem('restoreSession', '1')
  }

  const partnerToken = searchParams.get('partner')
  if (partnerToken) {
    sessionStorage.setItem('partnerToken', partnerToken)
  }

  const addressId = searchParams.get('address')
  if (addressId) {
    sessionStorage.setItem('addressId', addressId)
  }

  const cityId = searchParams.get('city')
  if (cityId) {
    sessionStorage.setItem('cityId', cityId)
  }

  return children
}
